
<div class="filter-title flat-status-title">{{ 'STATUS' | translate }}:</div>
<div class="flat-status-menu">
    <span>{{ currentFlatStatus }}</span>
    <div class="sub-menu-content">    
        <div (click)="showStatus('sold')" [class.active]="statusSold">{{ 'SOLD' | translate }}</div>
        <div (click)="showStatus('waiting')" [class.active]="statusWating">{{ 'IN-REGISTRATION' | translate }}
        </div>
        <div (click)="showStatus('free')" [class.active]="statusFree">{{ 'FREE' | translate }}</div>
        <div (click)="showStatus('remove-status')" [class.active]="!statusFree && !statusWating && !statusSold">{{ 'ALL'| translate }}
        </div>
    </div>
</div>